import { Body, Divider, Flex, Heading, SubTitle, Title } from '@teko/ds-mobile';
import { formatCurrency } from '@teko/teko-ecommerce';
import { DividerStyleEnum } from '@teko/types/dist/shared';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { t } from 'i18n';
import { useGetPriceDetailPage } from 'modules/product-detail/hooks/useGetPriceDetailPage';
import { isShowRetailPrice } from 'modules/product-detail/shared/helpers';

export const ProductPrice = () => {
  const { numberDisplayFormat, isMobile } = useTenantConfig();
  const { calculatePrice } = useGetPriceDetailPage();
  const { price, minAmountByMonth } = useProductDetailState();

  const supplierRetailPrice =
    formatCurrency(
      calculatePrice?.supplierRetailPrice as number,
      numberDisplayFormat,
    ) || '';
  const latestPrice =
    formatCurrency(price?.finalPrice as number, numberDisplayFormat) || '';
  const discountPercent = price?.discountPercent;

  const showRetailPrice =
    supplierRetailPrice &&
    isShowRetailPrice(
      calculatePrice?.supplierRetailPrice as number,
      price?.finalPrice as number,
    );

  const isShowDiscount = !!discountPercent;

  return (
    <Flex direction="column">
      <Divider
        dividerStyle={DividerStyleEnum.dashed}
        color="divider"
        gap={8}
        margin={[isMobile ? 's8' : 's12', 's0']}
      />
      <Flex direction="column" align="start">
        {(showRetailPrice || isShowDiscount) && (
          <Flex direction="row" gap="s8" height="1rem">
            {showRetailPrice && (
              <Body level={1} decoration="line-through" color="textSecondary">
                {supplierRetailPrice}
              </Body>
            )}
            {isShowDiscount && (
              <Body level={1} color="#F5222D">
                {discountPercent}
              </Body>
            )}
          </Flex>
        )}
        {isMobile ? (
          <Title level={1} color="primary500">
            {latestPrice}
          </Title>
        ) : (
          <Heading level={4} color="primary500">
            {latestPrice}
          </Heading>
        )}
      </Flex>
      {typeof minAmountByMonth === 'number' && (
        <Flex
          direction="column"
          backgroundColor="secondary100"
          height={60}
          width="100%"
          borderLeft="2px solid #4CB9CC"
          padding="s8"
          marginTop="s4"
        >
          <Body level={2} color="textTitle" textTransform="uppercase">
            {t('Mua trả góp')}
          </Body>
          <SubTitle level={2} color="secondary700">
            {formatCurrency(minAmountByMonth, numberDisplayFormat)}/{t('tháng')}
          </SubTitle>
        </Flex>
      )}
    </Flex>
  );
};
